module.exports = __webpack_public_path__ + "img/azw3-ic.eac25852.svg";